import { render, staticRenderFns } from "./AdvCardAddToCartButtonBase.vue?vue&type=template&id=184f5a53&scoped=true"
import script from "./AdvCardAddToCartButtonBase.vue?vue&type=script&lang=js"
export * from "./AdvCardAddToCartButtonBase.vue?vue&type=script&lang=js"
import style0 from "./AdvCardAddToCartButtonBase.vue?vue&type=style&index=0&id=184f5a53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184f5a53",
  null
  
)

export default component.exports